"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconRecyclingAndWaste = function IconRecyclingAndWaste(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M11.117 2.842a1 1 0 0 1 1.625-.15l.077.103 2.374 3.62 1.5-.982.31 5.57-4.98-2.51 1.497-.982-1.485-2.264-2.557 4.417-1.73-1.002zM2.843 13.333l4.83-2.79v5.58l-1.55-.895L5.1 17.002h4.902v2h-6.63a1 1 0 0 1-.918-1.397l.05-.1 1.886-3.277zm16.053-1.74 3 5.96a1 1 0 0 1-.778 1.444l-.115.006h-4.16v1.79l-4.84-2.79 4.84-2.79v1.79h2.537l-2.27-4.51z",
    clipRule: "evenodd"
  })));
};

export { IconRecyclingAndWaste, IconRecyclingAndWaste as default };
